<template>
  <setting-layout
    header-title="欢迎使用"
    footer-text="修改密码"
    @footer-click="handleChangePassword"
  >
    <div class="first-login-layout-container">
      <div class="content-wrapper">
        <el-row
          :gutter="20"
          class="info-row"
        >
          <el-col
            :span="4"
            class="label"
          >用户名</el-col>
          <el-col :span="20">{{ user.fullName }}</el-col>
        </el-row>
        <el-row
          :gutter="20"
          class="info-row"
        >
          <el-col
            :span="4"
            class="label"
          >密码</el-col>
          <el-col :span="20">{{ passwordPlaceholder }}</el-col>
        </el-row>
        <div class="messages">
          <p>为确保检测任务的安全性，请您在首次登录后先修改密码！</p>
          <p>如您在检测过程中需要帮助，可随时查看《产品文档》或联系技术支持。</p>
        </div>
      </div>
    </div>
  </setting-layout>
</template>

<script>
import SettingLayout from '@/components/setting-layout.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'FirstLogin',
  components: {
    SettingLayout,
  },
  computed: {
    ...mapGetters('user', ['user']),
  },
  data() {
    return {
      // In a real application, do not store or display actual passwords.
      // This is just for visual representation based on the image.
      passwordPlaceholder: 'xxxxxxxxxxxxxx',
    };
  },
  methods: {
    handleChangePassword() {
      this.$router.push({
        name: 'ResetPassword',
      });
    },
  },
};
</script>

<style scoped>
.first-login-layout-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.info-row {
  margin-bottom: 18px;
  font-size: 14px;
}

.label {
  font-weight: bold;
  color: #303133;
}

.messages {
  margin-top: 30px;
  margin-bottom: 30px; /* Footer will provide spacing below, so this might be reducible */
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
}

.messages p {
  margin-bottom: 8px;
}
</style>
